import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Game} from "../Game";
import {GameModeNames} from "../server/GameModeNames";
import {gsap} from "gsap";

export class BackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundContainer: PIXI.Container;
    private _baseBg: PIXI.spine.Spine;
    private _fsBg: PIXI.spine.Spine;
    private _mayhemBg: PIXI.spine.Spine;
    private _mainView: PIXI.Container;

    constructor() {
        super();
        this.name = "BackgroundElements";
        this.init();
    }

    public setMode(mode: string): void {
        let animName: string = "idle";

        // keep this order of conditions as mayhem can only be true in fs and if that is true we have to set mayhem. And check for main game first because mayhem outro will have next mode normal but mayhemSpin true.
        if (mode === GameModeNames.NORMAL || mode === GameModeNames.NORMAL_AVALANCHE) {
            this.swapBackgroundTo(this._baseBg, animName);
        } else if (Game.model.data.mayhemSpin) {
            this.swapBackgroundTo(this._mayhemBg, animName);
        } else if (mode === GameModeNames.FREESPIN || mode === GameModeNames.FREESPIN_AVALANCHE) {
            animName += "2";
            this.swapBackgroundTo(this._fsBg, animName);
        }

        Game.symbolFloors.removeTrack(0);

        // #343
        Game.symbolFloors.onGameModeChange(mode);

        // #366
        Game.wall.onGameModeChange(mode);
    }

    public onGridExpansion(scale: number, transform: number, duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this.scale, {
            x: scale,
            y: scale,
            duration: duration
        }, "0");
        tl.to(this, {
            x: transform,
            y: transform,
            duration: duration
        }, "<");

        return tl;
    }

    private init(): void {
        this._mainView = new PIXI.Container();
        this._backgroundContainer = new PIXI.Container();

        this._baseBg = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("baseBg"));
        this._baseBg.position.set(360);
        this._baseBg.state.setAnimation(0, "idle", true);

        this._fsBg = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("fsBg"));
        this._fsBg.position.set(360);
        this._fsBg.state.setAnimation(0, "idle2", true);

        this._mayhemBg = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("mayhemBg"));
        this._mayhemBg.position.set(360);
        this._mayhemBg.state.setAnimation(0, "idle", true);

        if (Game.model.isRestore && Game.hasGridExpanded) {
            this.onGridExpansion(Game.scaleFactor, (Game.scaleFactor === 0.8) ? 72 : 108, 0);
        }

        this._backgroundContainer.addChild(this._baseBg);

        this._mainView.addChild(this._backgroundContainer);
        this.addChild(this._mainView);
    }

    private swapBackgroundTo(newBackground: PIXI.spine.Spine, animName: string): void {
        newBackground.state.setAnimation(0, animName, true);
        this._backgroundContainer.addChildAt(newBackground, 0);

        if (this._backgroundContainer.children.length > 1) {
            (this._backgroundContainer.removeChildren(1)[0] as PIXI.spine.Spine).state.clearTracks();
        }
    }
}